export const TAG_EDITOR_COLORS = {
  TAG_BACKGROUND_ALPHA: 0.15,
} as const

export const TAG_EDITOR_THRESHOLDS = {
  MIN_TAGS_COUNT: 1,
} as const

export const TAG_EDITOR_STRINGS = {
  TAG_PREFIX: 'tag_',
  IP_JOURNAL_URL_PREFIX: '/menu/app/tabs/clients/client/',
  IP_JOURNAL_URL_SUFFIX: '/ip-journal',
} as const

export const CSS_CLASSES = {
  TAG_ANCHOR: 'tag-anchor',
} as const

export const HTML_ATTRIBUTES = {
  DATA_TAG_ID: 'data-tag-id',
  DATA_LABEL: 'data-label',
  DATA_COLOR: 'data-color',
  DATA_CATEGORY: 'data-category',
  DATA_CATEGORY_ID: 'data-category-id',
  CONTENTEDITABLE: 'contenteditable',
  CLASS: 'class',
  TITLE: 'title',
  ID: 'id',
} as const

export const HTML_VALUES = {
  TAG_TITLE_PREFIX: 'Tag: ',
} as const

export const CSS_STYLE_VALUES = {
  TAG_BORDER_WIDTH: '1px solid',
} as const

export const DOM_ELEMENT_NAMES = {
  SPAN: 'span',
  DIV: 'div',
} as const
